import { dialogDefault, DIALOG_BILL_PAYMENT } from "../consts";

const mydialog = { ...dialogDefault, payments: [], amount: 0 }

export const dialogBillPaymentAction =  payload => ({ type: DIALOG_BILL_PAYMENT, payload });

export default function billPaymentDialogReducer(state = mydialog, { type, payload }) {
   
    const actions = {
        [DIALOG_BILL_PAYMENT] : () => ({...payload })
    }

    return actions[type]?.call() || state;
}